"use client";
import type { Program } from "@/common/program/types";
import PartnerProgramRecommendations from "@/components/ParterProgramRecommendations";
import getFilters from "@/components/Search/utils/getFilters";
import { ConfigureProps } from "react-instantsearch";
import useTranslations from "@/i18n/useTranslations";

interface Props {
  degreeData: Program | null;
  title: string | null;
  subtitle: string | null;
}

function CrossSell({ degreeData, title, subtitle }: Props) {
  const t = useTranslations("DegreeTY");
  const partnersForProgramSearch = degreeData?.partners
    .filter((partner) => partner.name)
    .map((partner) => partner.name);

  const categories = degreeData?.skills?.map((skill) => skill.category);

  const configForSearch: ConfigureProps = {
    filters: getFilters(),
    disjunctiveFacets: ["partner"],
    disjunctiveFacetsRefinements: { partner: partnersForProgramSearch || [] },
    facets: ["product", "skills.category"],
    clickAnalytics: true,
    facetsRefinements: {
      product: ["executive education"],
      "skills.category": categories || [],
      "skillsData.category": categories || [],
    },
    hitsPerPage: 4,
  };

  return (
    <div className="mb-16">
      <PartnerProgramRecommendations
        key="relatedPrograms"
        location="single-course"
        title={title || t("wantToGetAhead")}
        titleComponent={
          <h2 className="text-2xl sm:text-3xl font-bold text-primary-500 mt-0 mb-6">
            {title || t("relatedPrograms")}
          </h2>
        }
        subtitle={subtitle || t("crossSellSubtitle")}
        cardsToDisplay={3}
        partners={partnersForProgramSearch}
        pageType="single-course"
        customConfigForSearch={configForSearch}
      />
    </div>
  );
}

export default CrossSell;
